import { CALL_API } from '../../util/RBRestMiddleware'
import NgrxAuth from '../../auth/Auth'

export const USER_LOADING = 'USER_LOADING'
export const USER_SUCCESS = 'USER_SUCCESS'
export const USER_FAILED = 'USER_FAILED'

export const fetchUser = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: '/userProfile',
        prefix: 'USER'
      }
    })
  }
}

export const USER_UPDATE_LOADING = 'USER_UPDATE_LOADING'
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS'
export const USER_UPDATE_FAILED = 'USER_UPDATE_FAILED'

export const updateUser = (profileInfo, onSuccess, onError) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: '/userProfile',
        method: 'put',
        query: profileInfo,
        prefix: 'USER_UPDATE',
        onSuccess,
        onError
      }
    })
  }
}

export const UPDATE_BANKING_LOADING = 'UPDATE_BANKING_LOADING'
export const UPDATE_BANKING_SUCCESS = 'UPDATE_BANKING_SUCCESS'
export const UPDATE_BANKING_FAILED = 'UPDATE_BANKING_FAILED'

export const updateBanking = (bankingInfo, onSuccess, onError) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/userProfile/${NgrxAuth.memberId}/UpdateBankingInformation`,
        method: 'put',
        query: bankingInfo,
        prefix: 'UPDATE_BANKING',
        onSuccess,
        onError
      }
    })
  }
}

// RESET SNACK
export const RESET_SNACK = 'RESET_SNACK'
export const resetSnack = () => {
  return {
    type: RESET_SNACK
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/userProfileActions.js